
import { Link, useLocation } from 'react-router-dom';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export function AdminLayout({ children }: AdminLayoutProps) {
  const location = useLocation();

  const menuItems = [
    { icon: 'ri-dashboard-line', label: '대시보드', path: '/admin-dashboard' },
    { icon: 'ri-file-list-3-line', label: '수료증 관리', path: '/admin/certificates' },
    { icon: 'ri-group-line', label: '학습자 관리', path: '/admin/students' },
    { icon: 'ri-layout-line', label: '템플릿 관리', path: '/admin/templates' },
    { icon: 'ri-file-copy-line', label: '증명서 발급', path: '/admin/bulk-issue' },
    { icon: 'ri-wallet-3-line', label: '정산 관리', path: '/admin/settlement' },
    { icon: 'ri-money-dollar-circle-line', label: '결제 내역', path: '/admin/payments' },
    { icon: 'ri-bar-chart-line', label: '통계 분석', path: '/admin/analytics' },
    { icon: 'ri-settings-3-line', label: '설정', path: '/admin/settings' },
  ];

  return (
    <div className="flex h-screen bg-gray-50">
      {/* 좌측 사이드바 */}
      <div className="w-64 bg-white border-r border-gray-200 flex flex-col">
        {/* 로고 영역 */}
        <div className="h-16 flex items-center px-6 border-b border-gray-200">
          <Link to="/admin-dashboard" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/01721397da55af21878e201cee4469af/22d693b8e5c7b9a7815f6764c73619aa.png" 
              alt="CEIS Logo" 
              className="h-8"
            />
          </Link>
        </div>

        {/* 메뉴 영역 */}
        <nav className="flex-1 px-4 py-6">
          <ul className="space-y-2">
            {menuItems.map((item, index) => (
              <li key={index}>
                <Link
                  to={item.path}
                  className={`flex items-center px-3 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                    location.pathname === item.path
                      ? 'bg-blue-50 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }`}
                >
                  <i className={`${item.icon} text-lg mr-3`}></i>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* 하단 사용자 정보 */}
        <div className="p-4 border-t border-gray-200">
          <div className="flex items-center">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
              <i className="ri-user-line text-blue-600"></i>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-900">관리자</p>
              <p className="text-xs text-gray-500">admin@ceis.co.kr</p>
            </div>
          </div>
        </div>
      </div>

      {/* 메인 콘텐츠 영역 */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* 상단 헤더 */}
        <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-6">
          <div className="flex items-center space-x-4">
            <button className="lg:hidden w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer">
              <i className="ri-menu-line text-lg"></i>
            </button>
          </div>
          <div className="flex items-center space-x-4">
            <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer">
              <i className="ri-notification-line text-lg"></i>
            </button>
            <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer">
              <i className="ri-settings-line text-lg"></i>
            </button>
          </div>
        </header>

        {/* 스크롤 가능한 콘텐츠 영역 */}
        <main className="flex-1 overflow-y-auto">
          {children}
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
